import { SIDE_NAV_WIDTH } from './components/side-nav/nav-items'
import { APP_HEADER_HEIGHT } from './components/app-header/styles'

const APP_BAR_MOBILE = 64
const APP_BAR_DESKTOP = 70

const styles = theme => ({
  '@global': {
    body: {
      margin: 0,
      padding: 0,
    },
    html: {
      fontSize: '100%',
    },
    main: {
      display: 'block',
    },
    '#root': {
      display: 'flex',
      //height: '100vh',
      width: '100%',
      zIndex: 1,
    },
  },
  enterasan: {
    display: 'block',
  },
  content: {
    position: 'absolute',
    top: 144,
    left: 0,
    right: 0,
    bottom: 0,
  },
  root: {
    display: 'flex',
    minHeight: '100%',
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      overflow: 'auto',
    },
  },
  editor: {
    flexGrow: 1,
    width: '100%',
    paddingBottom: theme.spacing(4),
  },
  main: {
    flexGrow: 1,
    //minHeight: '100%',
    width: '100%',
    marginTop: APP_BAR_MOBILE,
    //paddingTop: theme.spacing(2),
    //paddingBottom: theme.spacing(4),

    //paddingLeft: theme.spacing(2),
    //paddingRight: theme.spacing(2),

    //marginBottom: theme.spacing(3),
    /*
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
    [theme.breakpoints.up('lg')]: {
      paddingTop: APP_BAR_DESKTOP + 10,
      paddingLeft: theme.spacing(4),
      paddingRight: theme.spacing(4),
    },
    [theme.breakpoints.down('md')]: {
      paddingTop: APP_BAR_MOBILE + 40,
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
    },
    */
  },
  // Leaves room for the fixed side nav and header.
  shellMain: {
    flex: 1,
    minWidth: 0,
    minHeight: '100vh',
    marginLeft: SIDE_NAV_WIDTH,
    paddingTop: APP_HEADER_HEIGHT,
    display: 'flex',
    flexDirection: 'column',
    background: '#FFFFFF',
  },
  shellContent: {
    // Positioning context for pages that place elements with `position:
    // absolute` (e.g. a Back link at left: 32px); without it they are laid out
    // against the window and end up under the side nav.
    position: 'relative',
    flexGrow: 1,
    width: '100%',
  },
  // A section opened from the side nav fades in instead of popping in.
  sectionEnter: {
    animation: '$sectionEnter 200ms ease-out',
    '@media (prefers-reduced-motion: reduce)': {
      animation: 'none',
    },
  },
  '@keyframes sectionEnter': {
    // Opacity only: a transform would move position: fixed overlays meanwhile.
    from: { opacity: 0 },
    to: { opacity: 1 },
  },
  main_mobile: {
    flexGrow: 1,
    //minHeight: '100%',
    width: '100%',
    marginTop: APP_BAR_MOBILE,
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),

    //paddingLeft: theme.spacing(1),
    //paddingRight: theme.spacing(1),

    //marginBottom: theme.spacing(3),
    /*
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
    [theme.breakpoints.up('lg')]: {
      paddingTop: APP_BAR_DESKTOP + 10,
      paddingLeft: theme.spacing(4),
      paddingRight: theme.spacing(4),
    },
    [theme.breakpoints.down('md')]: {
      paddingTop: APP_BAR_MOBILE + 40,
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
    },
    */
  },
  backdrop: {
    width: '100%',
    height: '100%',
    position: 'absolute',
    zIndex: 1,
    backdropFilter: 'blur(8px)',
    display: 'none',
    textAlign: 'center',
    alignItems: 'center',
    justifyContent: 'flex-start',
    paddingLeft: 150,
  },
  button: {
    color: '#002E47',
    '&:hover': {
      backgroundColor: '#F4F6F8',
      color: '#002E47',
      border: 'none',
    },
  },
})

export default styles
